<a href="{{registerUrl}}"><span class="fa fa-user-plus">&nbsp;</span>Create Profile</a>
